import React from 'react'
import { FaSistrix } from 'react-icons/fa'
import { Button, Col, Input } from 'reactstrap'

export default function BuscadorTablas({ valor, onChange, onBuscar }) {
  return (
    <div className='d-flex justify-content-end my-3'>
      <Col sm={3} className='d-flex'>
        <Input
          className='mr-1'
          type='text'
          name='buscar'
          placeholder='Buscar...'
          value={valor}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              onBuscar(valor)
            }
          }}
        />
        <Button outline color='primary' onClick={() => onBuscar(valor)}>
          <FaSistrix />
        </Button>
      </Col>
    </div>
  )
}
